module.exports = __webpack_public_path__ + "media/images/map_tokyo_direction1-f10f97d06c07c93d6bc7f39c1570d828.jpg";